
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"13","height":"13","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.292 3.792l-.47 6.577a1.083 1.083 0 01-1.08 1.006H4.258a1.083 1.083 0 01-1.081-1.006l-.47-6.577m2.709 2.166v3.25m2.166-3.25v3.25m.542-5.416V2.167a.542.542 0 00-.542-.542H5.417a.542.542 0 00-.542.542v1.625m-2.708 0h8.666","stroke":"#0064FF","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    